import { Box, Stack } from "@mui/material";
import { KeyRoleMapper } from "../KeyRoleMapper";
import { KeyRoles, RoleStatus } from "../../../types/enums";
import { TriangleIcon } from "../../images";
import { useRef, useState } from "react";
import { DropdownSubItem } from "../../ui/dropdown/DropdownSubItem";
import { useOutsideClick } from "../../../hooks/useOutSideClick";
import { keyRolesItems } from "../../../types/genereal";
import { ReuseTooltip } from "../../ui";
import { RoleTooltip } from "../RoleTooltip";

export const RoleBodyCell = ({
  value,
  minWidth,
  maxWidth,
  justifyContent = "space-between",
  isEditMode,
  changeRoleHandler,
  isActive,
}: {
  value?: string;
  minWidth: string;
  maxWidth: string;
  justifyContent?: "space-between" | "center" | "flex-start" | "flex-end";
  isEditMode: boolean;
  changeRoleHandler: (role: KeyRoles) => void;
  isActive?: RoleStatus;
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  useOutsideClick({
    elementRef: dropdownRef,
    onOutsideClick: () => setIsOpen(false),
    isOpened: isOpen,
    wrapperRef: wrapperRef,
  });

  return (
    <Stack
      ref={wrapperRef}
      flexDirection="row"
      alignItems="center"
      minWidth={minWidth}
      maxWidth={maxWidth}
      justifyContent={justifyContent}
      width="100%"
      padding="0 16px"
      position="relative"
      onClick={() =>
        isEditMode && isActive === RoleStatus.active && setIsOpen(!isOpen)
      }
      style={{
        cursor:
          isEditMode && isActive === RoleStatus.active ? "pointer" : "auto",
      }}
      gap="8px"
      flexGrow={1}
    >
      {isEditMode && isActive === RoleStatus.active ? (
        <>
          <KeyRoleMapper item={value as KeyRoles} />
          <TriangleIcon rotate={isOpen ? "180" : "0"} />
        </>
      ) : (
        <>
          {value ? (
            <ReuseTooltip
              text={
                <RoleTooltip
                  tooltip={keyRolesItems[value as KeyRoles].tooltip}
                  activeStatus={isActive}
                />
              }
              hideChildren={false}
            >
              <KeyRoleMapper item={value as KeyRoles} roleStatus={isActive} />
            </ReuseTooltip>
          ) : (
            "--"
          )}
        </>
      )}
      {isOpen && (
        <Box
          ref={dropdownRef}
          sx={{
            position: "absolute",
            top: "Calc(100% + 8px)",
            left: 0,
            zIndex: 9999,
            backgroundColor: "white",
            boxShadow: "0px 4px 15px 0px #00000040",
            borderRadius: "8px",
            width: "184px",
            maxHeight: "220px",
            overflow: "auto",
          }}
        >
          {Object.keys(KeyRoles).map((el) => (
            <DropdownSubItem
              key={el}
              withCheckbox={false}
              title={el}
              checked={value === el}
              onClick={() => changeRoleHandler(el as KeyRoles)}
              renderItem={(title) => (
                <Stack padding="8px" alignItems="flex-start">
                  <KeyRoleMapper
                    item={title as KeyRoles}
                    roleStatus={isActive}
                  />
                </Stack>
              )}
            />
          ))}
        </Box>
      )}
    </Stack>
  );
};
